import { createFileRoute } from "@tanstack/react-router"
import { api } from "~/utils/api"
import ComparisonPricingTable from "~/components/ComparisonPricingTable"
import MarketingPricingFAQ from "~/components/Marketing/MarketingPricingFAQ"
import MarketingLayout from "~/layouts/MarketingLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { getPageSEO } from "~/utils/seo"

export const Route = createFileRoute("/viral/pricing")({
  component: PricingPage,
})

function PricingPage() {
  const { data: products } = api.subscriptions.getProducts.useQuery()
  const pricingSEO = getPageSEO("pricing")

  return (
    <MarketingLayout>
      <CustomHead
        title={pricingSEO.title}
        description={pricingSEO.description}
        keywords={pricingSEO.keywords}
        pageType={pricingSEO.pageType}
        url="https://vidmax.ai/pricing"
      />

      <ComparisonPricingTable products={products ?? []} />
      <MarketingPricingFAQ className="mb-20" />
    </MarketingLayout>
  )
}
